import { render, staticRenderFns } from "./LearnOnlyDeviceNotice.vue?vue&type=template&id=4cf6b81a&scoped=true"
import script from "./LearnOnlyDeviceNotice.vue?vue&type=script&lang=js"
export * from "./LearnOnlyDeviceNotice.vue?vue&type=script&lang=js"
import style0 from "./LearnOnlyDeviceNotice.vue?vue&type=style&index=0&id=4cf6b81a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6b81a",
  null
  
)

export default component.exports